import React, {useState} from "react";
import {Link, withRouter} from "react-router-dom";
import {useDispatch} from "react-redux";
import profileActions from "../../redux/profile/actions";
import LogoTop from "../../components/LogoTop";
import StyledFirebaseAuth from "react-firebaseui/StyledFirebaseAuth";
import firebase from "firebase/app";

function Login(props) {
    const [userName, setUserName] = useState("");
    const [password, setPassword] = useState("");
    const dispatch = useDispatch();

    async function login() {
        if (!userName || !password) {
            return;
        }
        dispatch({
            type: profileActions.AUTH_USER,
            payload: {
                userName,
                password,
            },
        });
    }

    const uiConfig = {
        signInFlow: "popup",
        signInOptions: [
            firebase.auth.GoogleAuthProvider.PROVIDER_ID,
        ],
        tosUrl: "/",
        privacyPolicyUrl: function () {
            window.location.assign("/");
        },
        callbacks: {
            signInSuccessWithAuthResult: (authResult, redirectUrl) => false,
        },
    };

    document.title = "Login";

    return (
        <>
            <LogoTop></LogoTop>
            <div className="row mx-0">
                <div
                    className="col-lg-5 d-none d-lg-block p-0 min-vh-100 bg-image-cover bg-no-repeat bg-pos-center bg-danger"
                    style={{ background: "url(./assets/images/login-bg.jpg)" }}
                ></div>
                <div className="col-lg-7 min-vh-100 align-items-center d-flex bg-white">
                    <div className="card shadow-none border-0 ms-auto me-auto my-auto entry-card">
                        <div className="card-body rounded-0 l1">
                            <h2 className="fw-bold mb-3">
                                Login into <br />
                                your account
                            </h2>
                            <form>
                                <div className="form-group mb-3">
                                    <div className="input-withicon">
                                        <input
                                            type="email"
                                            className="form-control form-control-lg fw-600"
                                            id="email"
                                            placeholder="Your Email Address"
                                            value={userName}
                                            onChange={(e) => setUserName(e.target.value)}
                                        />
                                        <svg className="icon">
                                            <use href="#icon_email"></use>
                                        </svg>
                                    </div>
                                </div>
                                <div className="form-group icon-input mb-1">
                                    <div className="input-withicon">
                                        <input
                                            type="password"
                                            className="form-control form-control-lg fw-600"
                                            id="password"
                                            placeholder="Password"
                                            value={password}
                                            onChange={(e) => setPassword(e.target.value)}
                                        />
                                        <svg className="icon">
                                            <use href="#icon_lock"></use>
                                        </svg>
                                    </div>
                                </div>
                                <div className="d-flex mb-3">
                                    <label className="form-check mt-2">
                                        <input
                                            className="form-check-input"
                                            type="checkbox"
                                            value=""
                                        />
                                        <div className="form-check-label text-grey">
                                            Remember me
                                        </div>
                                    </label>
                                    <Link
                                        to="/ChangePassword"
                                        className="fw-semibold ms-auto text-dark mt-2 text-decoration-none">
                                        Forgot Password?
                                    </Link>
                                </div>
                            </form>
                            <h6 className="text-grey text-start py-2">
                                Dont have account{" "}
                                <Link
                                    to="/signup"
                                    className="fw-semibold text-decoration-none text-primary ms-1">
                                    Register
                                </Link>
                            </h6>
                            <div className="w-100">
                                <div className="form-group mb-1">
                                    <button
                                        type="submit"
                                        className="btn btn-lg btn-primary rounded-pill1 w-100"
                                        onClick={login}
                                    >
                                        Login
                                    </button>
                                    <div className="w-100 text-center mt-3">
                                        <h6 className="mb-0 text-grey mb-3">Or, Sign in with your social account</h6>
                                    </div>
                                    <StyledFirebaseAuth
                                        style={{ width: '100%' }}
                                        uiConfig={uiConfig}
                                        firebaseAuth={firebase.auth()}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default withRouter(Login);

